export const showToast = (message, duration = 6000) => {
  const alertBox = document.createElement('div');
  alertBox.className = 'custom-alert';
  alertBox.textContent = message;
  document.body.appendChild(alertBox);

  setTimeout(() => alertBox.classList.add('show'), 10);

  setTimeout(() => {
    alertBox.classList.remove('show');
    setTimeout(() => alertBox.remove(), 300);
  }, duration);
};
